import { LockClosedOutline, UserGroupOutline } from '@bonusly/design-system';

import { BonusPrivacy } from '../../../../../../types/bonus';

export const usePrivacyBadge = (privacy: BonusPrivacy) => {
	if (privacy === BonusPrivacy.Team) {
		return {
			icon: <UserGroupOutline size="xs" />,
			text: 'Shared with team',
			tooltip: 'This post is visible to anyone tagged, their managers, their teams, and admins',
		};
	}

	return {
		icon: <LockClosedOutline size="xs" />,
		text: 'Shared privately',
		tooltip: 'This post is visible to anyone tagged, their managers, and admins',
	};
};
